/* ===============================
   MONOGRAM CHARACTER LIMIT + COUNTER
   =============================== */
(function () {
  const MAX = 1;

  function isMonogramField(el) {
    if (!el) return false;

    const tag = el.tagName?.toLowerCase();
    if (!['input', 'textarea'].includes(tag)) return false;

    const name = (el.getAttribute('name') || '').toLowerCase();
    const placeholder = (el.getAttribute('placeholder') || '').toLowerCase();
    const id = (el.getAttribute('id') || '').toLowerCase();

    if (name.includes('properties') && (name.includes('monogram') || name.includes('personal'))) return true;
    if (placeholder.includes('single letter') || placeholder.includes('monogram')) return true;
    if (id.includes('monogram') || id.includes('personal')) return true;

    const label = document.querySelector(`label[for="${el.id}"]`);
    if ((label?.textContent || '').toLowerCase().includes('monogram')) return true;

    return false;
  }

  function attachCounter(input) {
    if (input.dataset.charcountAttached) return;
    input.dataset.charcountAttached = 'true';

    input.maxLength = MAX;

    const counter = document.createElement('div');
    counter.className = 'charcount';
    input.insertAdjacentElement('afterend', counter);

    const update = () => {
      const remaining = Math.max(0, MAX - (input.value || '').length);
      counter.textContent = `${remaining} ${remaining === 1 ? 'character left' : 'characters left'}`;
    };

    input.addEventListener('input', update);
    update();
  }

  function scan() {
    document.querySelectorAll('input, textarea').forEach(el => {
      if (isMonogramField(el)) attachCounter(el);
    });
  }

  scan();
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
})();


/* ===============================
   TRACK USER CHOICES FOR FONT + THREAD COLOR
   - We do NOT try to force the dropdown UI (apps re-render)
   - We locate selects by label text (best-effort).
   =============================== */
(function () {
  function labelTextFor(el) {
    const wrap = el.closest('.product-form__input, .field, .form-field, .option') || el.parentElement;
    return (wrap?.querySelector('label')?.textContent || '').trim().toLowerCase();
  }

  function findSelects() {
    const selects = Array.from(document.querySelectorAll('select'));

    const colorSel = selects.find(s => {
      const lab = labelTextFor(s);
      return lab.includes('thread color') || (lab.includes('color') && !lab.includes('font'));
    });

    const fontSel = selects.find(s => labelTextFor(s).includes('font'));

    return { colorSel, fontSel };
  }

  // Expose helper for validation
  window.__cc_selects = findSelects;

  // (Optional) keep listener for tracking - doesn't control validation anymore
  function attach() {
    const { colorSel, fontSel } = findSelects();

    const markUserChosen = (sel) => {
      if (!sel || sel.dataset.choiceListener === 'true') return;
      sel.dataset.choiceListener = 'true';

      sel.addEventListener('change', () => {
        const v = (sel.value || '').trim();
        const t = (sel.options?.[sel.selectedIndex]?.textContent || '').trim().toLowerCase();
        if (v && !t.startsWith('select ')) sel.dataset.userChosen = 'true';
      });
    };

    markUserChosen(colorSel);
    markUserChosen(fontSel);
  }

  attach();
  new MutationObserver(attach).observe(document.documentElement, { childList: true, subtree: true });
})();


/* ===============================
   ADD-TO-CART VALIDATION + SHOPIFY FIX
   - Fix malformed app payload: properties[] -> properties[Label]
   - Block add-to-cart until thread + font have real values (not placeholders)
   - Patch fetch (most themes using AJAX cart)
   =============================== */
(function () {
  function inferLabel(input) {
    if (input?.id) {
      const l = document.querySelector(`label[for="${CSS.escape(input.id)}"]`);
      if (l) return l.textContent.trim();
    }
    const wrap = input?.closest?.('.product-form__input, .field, .form-field, .option') || input?.parentElement;
    return wrap?.querySelector?.('label')?.textContent?.trim() || null;
  }

  function normalizePropertiesFormData(fd) {
    const entries = Array.from(fd.entries());
    const hasArray = entries.some(([k]) => k === 'properties[]' || k === 'properties');
    if (!hasArray) return fd;

    const cleaned = new FormData();
    const values = entries
      .filter(([k]) => k === 'properties[]' || k === 'properties')
      .map(([, v]) => v);

    entries.forEach(([k, v]) => {
      if (k !== 'properties[]' && k !== 'properties') cleaned.append(k, v);
    });

    const inputs = Array.from(document.querySelectorAll(
      'input[name="properties[]"], select[name="properties[]"], textarea[name="properties[]"], input[name="properties"], select[name="properties"], textarea[name="properties"]'
    ));

    values.forEach((v, i) => {
      const label = inferLabel(inputs[i]) || `Personalization ${i + 1}`;
      cleaned.append(`properties[${label}]`, v);
    });

    return cleaned;
  }

  function isBadSelectValue(sel) {
    if (!sel) return false; // if not found, don't block
    const v = (sel.value || '').trim();
    const t = (sel.options?.[sel.selectedIndex]?.textContent || '').trim().toLowerCase();

    if (!v) return true;
    if (t.startsWith('select ') || t.startsWith('choose ') || t.startsWith('pick ')) return true;
    return false;
  }

  function missingFontOrColor() {
    const finder = window.__cc_selects;
    if (!finder) return false;

    const { colorSel, fontSel } = finder();

    // Only enforce if the selects exist on this page
    if (colorSel && isBadSelectValue(colorSel)) return true;
    if (fontSel && isBadSelectValue(fontSel)) return true;

    return false;
  }

  const originalFetch = window.fetch;

  window.fetch = async function (input, init) {
    const url = typeof input === 'string' ? input : (input?.url || '');

    if (url.includes('/cart/add') && init?.body instanceof FormData) {
      // Always normalize first so Shopify never sees properties[] again
      const normalized = normalizePropertiesFormData(init.body);

      // Enforce thread + font selections (only if selects exist)
      if (missingFontOrColor()) {
        alert('Please select a thread color and font before adding to cart.');

        // Return a normal response instead of rejecting (prevents theme/app breakage)
        return new Response(
          JSON.stringify({ status: 422, message: 'Thread color and font required' }),
          { status: 422, headers: { 'Content-Type': 'application/json' } }
        );
      }

      init = { ...init, body: normalized };
    }

    return originalFetch.call(this, input, init);
  };
})();

